import React, {Component} from 'react';
import {connect} from 'react-redux';
import {path} from "ramda";

import Box from 'components/box';
import {AccostDetailList} from './accost-detail-list';
import Spinner from 'spinner';

import {loadAccostDetail} from 'redux/actions/portal/institutions';

const mapStateToProps = state => ({
  accost: state.institutions.get('accostDetail')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => dispatch(loadAccostDetail(id))
});

class ReviewDetail extends Component {

  componentDidMount() {
    this.props.onLoad(this.props.match.params.review_id)
  }

  render() {

    if (this.props.accost === undefined) {
      return <Spinner/>;
    }

    return(
      <Box title4={`${path(['location', 'state', 'name'], this.props) || 'Звернення'} користувача`}>
        <AccostDetailList accost={this.props.accost} />
        {this.props.accost.get('answer') &&
          <p style={{marginTop: "20px", fonSize: "18px"}}>Коментар адміністрації до звернення: <strong>{this.props.accost.get('answer')}</strong></p>
        }
      </Box>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewDetail);



// WEBPACK FOOTER //
// ./src/cabinet/reviews/detail.js